import React, { useRef, useEffect, useState } from "react";
import $ from "jquery";
import { useDispatch } from "react-redux";
import contriesList from "iso-3166-1-alpha-2";
import * as R from "ramda";
import { CustomPensionForm } from "./customPensionForm";
import { addServiceData, updateServiceData, deleteServiceData } from "../../../../../actions/services-api";
import { generateLettersForUserIdAndUserServiceId } from "../../../../../actions/events-api";

import ServiceData from "../../../../../constants/models/serviceData";
import Pension from "../../../../../constants/models/servicePayloads/pension";
import { ConnectionTypes, convertConnectionTypesToServiceType, PensionProfessionalCategoryMapping } from "../../../../../constants/utils/connectionTypes";
import OtherActivity from "../../../../../constants/models/servicePayloads/otherActivity";

export const PensionDetails = ({ index, pension, user, removePension, services, generateRelocationLetters }) => {
	var countries = require("i18n-iso-countries");
	countries.registerLocale(require("i18n-iso-countries/langs/fr.json"));
	const dispatch = useDispatch();
	const [selectedCategory, setSelectedCategory] = useState(undefined);

	const formRef = useRef(null);
	let initCollapsedState = true;
	let initState = new Pension({
		type: "Retraite",
		professionalCategory: "",
		pensionBaseServiceId: "",
		pensionComplementServiceId: "",
	});
	let showCustomBasePensionFormInit = false;
	let showCustomComplementaryPensionFormInit = false;
	let showBasePensionFormInit = true;
	let showComplementaryPensionFormInit = true;
	if (!R.isNil(pension.id)) {
		initState = pension.payload;
		let category = PensionProfessionalCategoryMapping.find((c) => c.options.find((o) => o.value === pension.payload.professionalCategory) !== undefined);

		if (!R.isNil(category) && R.isNil(selectedCategory)) {
			setSelectedCategory(category);
		}
		initCollapsedState = false;

		if (!R.isNil(pension.payload.customPensionBase) && !R.isNil(pension.payload.customPensionBase.name)) {
			showCustomBasePensionFormInit = true;
			showBasePensionFormInit = false;
		}
		if (!R.isNil(pension.payload.customPensionComplement) && !R.isNil(pension.payload.customPensionComplement.name)) {
			showCustomComplementaryPensionFormInit = true;
			showComplementaryPensionFormInit = false;
		}
		if ((R.isNil(pension.payload.pensionBaseServiceId) || pension.payload.pensionBaseServiceId === "") && (R.isNil(pension.payload.customPensionBase) || R.isNil(pension.payload.customPensionBase.name))) {
			showBasePensionFormInit = false;
		}
		if ((R.isNil(pension.payload.pensionComplementServiceId) || pension.payload.pensionComplementServiceId === "") && (R.isNil(pension.payload.customPensionComplement) || R.isNil(pension.payload.customPensionComplement.name))) {
			showComplementaryPensionFormInit = false;
		}
	}

	const [showCustomBasePensionForm, setShowCustomBasePensionForm] = useState(showCustomBasePensionFormInit);
	const [showCustomComplementaryPensionForm, setShowCustomComplementaryPensionForm] = useState(showCustomComplementaryPensionFormInit);

	const [showBasePensionForm, setShowBasePensionForm] = useState(showBasePensionFormInit);
	const [showComplementaryPensionForm, setShowComplementaryPensionForm] = useState(showComplementaryPensionFormInit);

	const [payload, setPayload] = useState(initState);
	const [collapsed, setCollapsed] = useState(initCollapsedState);
	let pensionBase = undefined;
	let pensionsComplementary = undefined;
	let selectedPensionComplementary = undefined;
	let branchBase = undefined;
	let branchComplementary = undefined;
	let selectedProfessionalSubcategoryTitle = undefined;
	if (payload.professionalCategory !== "") {
		pensionBase = services.find(s => !R.isNil(s.mapping[payload.professionalCategory]) && s.mapping[payload.professionalCategory].includes("Base") && s.name !== "ONaCVG");
		if (!R.isNil(pensionBase)) {
			branchBase = pensionBase.branches.find((b) => b.id === payload.pensionBaseServiceId);
		}

		pensionsComplementary = services.filter((s) => !R.isNil(s.mapping) && !R.isNil(s.mapping[payload.professionalCategory]) && s.mapping[payload.professionalCategory].includes("Complementary"));

		if (payload.pensionComplementServiceId !== "") {
			selectedPensionComplementary = pensionsComplementary.find((p) => p.branches.find((b) => b.id === payload.pensionComplementServiceId) !== undefined);
			if (!R.isNil(selectedPensionComplementary)) branchComplementary = selectedPensionComplementary.branches.find((b) => b.id === payload.pensionComplementServiceId);
		} else {
			if (pensionsComplementary.length > 1) {
				selectedPensionComplementary = undefined;
			} else {
				selectedPensionComplementary = pensionsComplementary[0];
			}
		}

		PensionProfessionalCategoryMapping.forEach((cat) => {
			let matchingOption = cat.options.find((o) => o.value === payload.professionalCategory);
			if (!R.isNil(matchingOption)) {
				selectedProfessionalSubcategoryTitle = matchingOption.title;
			}
		});
		// if(payload.professionalCategory === "Autres"){
		//     selectedProfessionalSubcategoryTitle = "Autres";
		// }
	}

	useEffect(() => {
		$('[data-toggle="tooltip"]').tooltip();
	}, []);

	useEffect(() => {
		if (R.isNil(pension.id)) {
			setShowBasePensionForm(true);
			setShowComplementaryPensionForm(true);
		}
	}, [selectedCategory, payload.professionalCategory]);

	return (
		<section className={"card card-body" + (index === 0 ? "" : " mt-4")} id={"activity" + index}>
			<div className="card-header p-0" id="headingUserDetail" role="button" onClick={() => setTimeout(() => setCollapsed(!collapsed), 200)}>
				<div className="flex-row align-items-center justify-content-lg-between" data-toggle="collapse" data-target={"#accordionActivities" + index} aria-expanded={collapsed} aria-controls="accordionActivities">
					<h4 className="h3 font-weight-black container-tight my-auto">{index === 0 ? "Votre retraite principale" : "Autre retraite"}</h4>
					{payload.professionalCategory !== "" ? (
						<span className="mr-auto align-middle">
							<i className="eva eva-arrow-right mx-2 align-middle o-30"></i>
							<span className="o-60 align-middle">{selectedProfessionalSubcategoryTitle}</span>
						</span>
					) : (
						""
					)}
					<button type="button" className="btn btn-icon p-0 text-uppercase font-weight-demi fs-4 my-auto ml-auto m-lg-1 o-40" name="refPrincipal">
						<i className={"eva " + (!collapsed ? "eva-arrow-ios-upward-outline" : "eva-arrow-ios-downward-outline")}></i>
					</button>
				</div>
			</div>
			<div className={"collapse" + (collapsed ? " show" : "")} id={"accordionActivities" + index} aria-labelledby="headingUserDetail" data-parent={"#activity" + index}>
				<form className="block" noValidate ref={formRef}>
					<h5 className="h4 text-uppercase text-secondary font-weight-black mb-sm mt-4">Catégorie sociaux professionelle avant la retraite</h5>
					<div className="row gx-2 mt-n2">
						<div className="col-12 col-md-12">
							<div className="form-group">
								<select
									className="custom-select"
									id={"contrat" + index}
									value={R.isNil(selectedCategory) ? "none" : selectedCategory.title}
									onChange={(e) => {
										formRef.current.classList.remove("was-validated");
										if (e.target.value === "none") {
											setSelectedCategory(undefined);
											setPayload({ ...payload, professionalCategory: "", pensionComplementServiceId: "", pensionBaseServiceId: "" });
										} else {
											let category = PensionProfessionalCategoryMapping.find((c) => c.title === e.target.value);
											if (!R.isNil(category)) {
												setSelectedCategory(category);
												if (category.title !== "Autres") {
												let pensionBase = services.find(s => !R.isNil(s.mapping[category.options[0].value]) && s.mapping[category.options[0].value].includes("Base") && s.name !== "ONaCVG");
													let pensionComplementary = services.find((s) => !R.isNil(s.mapping) && !R.isNil(s.mapping[category.options[0].value]) && s.mapping[category.options[0].value].includes("Complementary"));
													setPayload({
														...payload,
														professionalCategory: category.options[0].value,
														pensionBaseServiceId: R.isNil(pensionBase) || pensionBase.branches.length > 1 ? "" : pensionBase.branches[0].id,
														pensionComplementServiceId: R.isNil(pensionComplementary) || pensionComplementary.branches.length > 1 ? "" : pensionComplementary.branches[0].id,
													});
													setShowCustomComplementaryPensionForm(false);
													setShowCustomBasePensionForm(false);
												} else {
													setShowCustomComplementaryPensionForm(true);
													setShowCustomBasePensionForm(true);
													setPayload({ ...payload, professionalCategory: "Autres" });
												}
											}
										}
									}}>
									<option value="none">Choisir catégorie socio-professionnelle</option>
									{PensionProfessionalCategoryMapping.map((category, index) => {
										return (
											<option key={index} value={category.title}>
												{category.title}
											</option>
										);
									})}
								</select>
							</div>
						</div>
					</div>
					{!R.isNil(selectedCategory) && selectedCategory.title !== "Autres" ? (
						<div className="row gx-2 mt-n2">
							<div className="col-12 col-md-12">
								<div className="form-group">
									<select
										className="custom-select"
										id={"contrat" + index}
										value={payload.professionalCategory}
										onChange={(e) => {
											let pensionBase = services.find(s => !R.isNil(s.mapping[e.target.value]) && s.mapping[e.target.value].includes("Base") && s.name !== "ONaCVG");
											let pensionComplementary = services.filter((s) => !R.isNil(s.mapping) && !R.isNil(s.mapping[e.target.value]) && s.mapping[e.target.value].includes("Complementary"));
											setPayload({
												...payload,
												professionalCategory: e.target.value,
												pensionBaseServiceId: R.isNil(pensionBase) || pensionBase.branches.length > 1 ? "" : pensionBase.branches[0].id,
												pensionComplementServiceId: pensionComplementary.length > 1 ? "" : R.isNil(pensionComplementary[0]) || pensionComplementary[0].branches.length > 1 ? "" : pensionComplementary[0].branches[0].id,
											});
										}}>
										{selectedCategory.options.map((option, index) => {
											return (
												<option key={index} value={option.value}>
													{option.title}
												</option>
											);
										})}
									</select>
								</div>
							</div>
						</div>
					) : (
						""
					)}

					{payload.professionalCategory !== "" ? (
						<React.Fragment>
							{showBasePensionForm || showCustomBasePensionForm ? (
								<React.Fragment>
									<hr className="mb-gutter" />
									<div className="grid-sm grid-sm-1 grid-md-2 align-items-center mt-2 mb-sm">
										<div className="block my-auto">
											<h5 className="h4 text-uppercase text-secondary font-weight-black">
												Régime de base
												{showComplementaryPensionForm && R.isNil(pension.id) ? (
													<button
														type="button"
														className="btn p-0 align-middle text-gray no-outline text-md-left fs-3 o-40"
														onClick={(e) => {
															setShowBasePensionForm(false);
															setShowCustomBasePensionForm(false);
															setPayload({ ...payload, pensionBaseServiceId: "" });
														}}>
														<i className="eva eva-trash-2-outline fs-root"></i>
													</button>
												) : (
													""
												)}
											</h5>
										</div>
										{payload.professionalCategory === "Autres" ? (
											""
										) : (
											<div className="ml-md-auto">
												{showCustomBasePensionForm ? (
													<button
														type="button"
														className="btn p-0 align-middle text-gray no-outline text-md-right"
														onClick={(e) => {
															e.preventDefault();
															setShowCustomBasePensionForm(false);
															setPayload({ ...payload, customPensionBase: new OtherActivity() });
														}}>
														Revenir à la liste des <span className="text-uppercase">régimes</span> <i className="eva eva-plus-circle-outline fs-lead align-middle text-secondary"></i>
													</button>
												) : (
													<button
														type="button"
														className="btn p-0 align-middle text-gray no-outline text-md-right"
														onClick={(e) => {
															e.preventDefault();
															setShowCustomBasePensionForm(true);
															setPayload({ ...payload, pensionBaseServiceId: "" });
															formRef.current.classList.remove("was-validated");
														}}>
														Cliquez ici si vous ne trouvez pas votre <span className="text-uppercase">régime</span> <i className="eva eva-plus-circle-outline fs-lead align-middle text-secondary"></i>
													</button>
												)}
											</div>
										)}
									</div>
									{showCustomBasePensionForm ? (
										<CustomPensionForm index={index} payload={payload.customPensionBase} setPayload={(val) => setPayload({ ...payload, customPensionBase: val })} />
									) : (
										<div className="row gx-2 mt-n2">
											<div className="col-12 col-md-5">
												<div className="form-group">
													<label className="h6 font-weight-bolder my-auto" htmlFor={"companyName" + index}>
														Nom du régime
													</label>
													<input type="text" className="form-control" id={"companyName" + index} disabled placeholder="Entreprise" value={R.isNil(pensionBase) ? "" : pensionBase.name} />
												</div>
											</div>
											<div className="col-12 col-md-7">
												<div className="form-group">
													<label className="h6 font-weight-bolder my-auto" htmlFor={"Adresseentreprise" + index}>
														Agence
													</label>
													<select className="custom-select" id={"branch" + index} value={payload.pensionBaseServiceId === "" ? "" : payload.pensionBaseServiceId} onChange={(e) => setPayload({ ...payload, pensionBaseServiceId: e.target.value })} required>
														{pensionBase.branches.length > 1 ? <option value="">Veuillez choisir une option</option> : ""}
														{pensionBase.branches.map((branch, index) => {
															return (
																<option key={index} value={branch.id}>
																	{branch.name}
																</option>
															);
														})}
													</select>
												</div>
												<div className="form-group">
													<div className="flex-row gx-2 align-items-center mb-1">
														<label className="h6 font-weight-bolder my-auto" htmlFor={"Adresseentreprise" + index}>
															Adresse ligne 1
														</label>
														<p
															className="form-text small text-gray my-auto ml-auto"
															data-toggle="tooltip"
															data-placement="top"
															data-html="true"
															data-template='<div class="tooltip" role="tooltip"><div class="arrow"></div><div class="tooltip-inner px-3 py-2 fs-2"></div></div>'
															title="L'adresse de l'organisme est nécessaire afin de pouvoir le contacter et d'effectuer les démarches.">
															<i className="eva eva-info-outline mr-1 fs-sm lh-root align-middle"></i>
														</p>
													</div>
													<input required type="text" className="form-control" id={"Adresseentreprise" + index} placeholder="Adresse de l'agence" value={R.isNil(branchBase) ? "" : branchBase.address.streetAddress} disabled="disabled" />
													<div className="invalid-feedback">
														<i className="eva eva-alert-triangle-outline text-warning mr-1 fs-sm lh-root align-middle"></i>
														<span className="align-middle text-dark o-70">Ce champ est requis</span>
													</div>
												</div>
												<div className="form-group">
													<label className="label h6 font-weight-bold my-auto" htmlFor={"Adresseligne2" + index}>
														Adresse ligne 2
													</label>
													<input type="text" className="form-control rounded" id={"Adresseligne2" + index} value={R.isNil(branchBase) ? "" : R.isNil(branchBase.address.streetAddress2) ? "" : branchBase.address.streetAddress2} disabled="disabled" />
												</div>
												<div className="form-row">
													<div className="form-group col-12 col-sm-6 col-lg">
														<label className="h6 font-weight-bolder my-auto" htmlFor={"Postalentreprise" + index} required>
															Code Postal
														</label>
														<input required type="text" className="form-control" id={"Postalentreprise" + index} placeholder="ex: 75001" value={R.isNil(branchBase) ? "" : branchBase.address.postalCode} disabled="disabled" />
														<div className="invalid-feedback">
															<i className="eva eva-alert-triangle-outline text-warning mr-1 fs-sm lh-root align-middle"></i>
															<span className="align-middle text-dark o-70">Ce champ est requis</span>
														</div>
													</div>
													<div className="form-group col-12 col-sm-6 col-lg">
														<label className="h6 font-weight-bolder my-auto" htmlFor={"Villeentreprise" + index} required>
															Ville
														</label>
														<input required type="text" className="form-control" id={"Villeentreprise" + index} placeholder="ex: Paris" value={R.isNil(branchBase) ? "" : branchBase.address.addressLocality} disabled="disabled" />
														<div className="invalid-feedback">
															<i className="eva eva-alert-triangle-outline text-warning mr-1 fs-sm lh-root align-middle"></i>
															<span className="align-middle text-dark o-70">Ce champ est requis</span>
														</div>
													</div>
													<div className="form-group col-12 col-sm-6 col-lg">
														<label className="h6 font-weight-bolder my-auto" htmlFor={"Paysentreprise" + index}>
															Pays
														</label>
														<select className="custom-select" id={"Paysentreprise" + index} value={R.isNil(branchBase) ? "" : branchBase.address.addressCountry} disabled="disabled">
															{Object.keys(contriesList.getData()).map((country, idx) => {
																return (
																	<option key={idx} value={country}>
																		{countries.getName(country, "fr", { select: "official" })}
																	</option>
																);
															})}
														</select>
													</div>
												</div>
											</div>
										</div>
									)}
								</React.Fragment>
							) : (
								""
							)}

							{showComplementaryPensionForm || showCustomComplementaryPensionForm ? (
								<React.Fragment>
									<hr className="mb-gutter" />
									<div className="grid-sm grid-sm-1 grid-md-2 align-items-center mt-2 mb-sm">
										<h5 className="h4 text-uppercase text-secondary font-weight-black">
											Régime complémentaire
											{showBasePensionForm && R.isNil(pension.id) ? (
												<button
													type="button"
													className="btn p-0 align-middle text-gray no-outline text-md-left fs-3 o-40"
													onClick={(e) => {
														setShowComplementaryPensionForm(false);
														setShowCustomComplementaryPensionForm(false);
														setPayload({ ...payload, pensionComplementServiceId: "" });
													}}>
													<i className="eva eva-trash-2-outline fs-root"></i>
												</button>
											) : (
												""
											)}
										</h5>
										{payload.professionalCategory === "Autres" ?(
											""
										) : (
											<div className="ml-md-auto">
												{showCustomComplementaryPensionForm ? (
													<button
														type="button"
														className="btn p-0 align-middle text-gray no-outline text-md-right"
														onClick={(e) => {
															e.preventDefault();
															setShowCustomComplementaryPensionForm(false);
															setPayload({ ...payload, customPensionBase: new OtherActivity() });
														}}>
														Revenir à la liste des <span className="text-uppercase">régimes</span> <i className="eva eva-plus-circle-outline fs-lead align-middle text-secondary"></i>
													</button>
												) : (
													<button
														type="button"
														className="btn p-0 align-middle text-gray no-outline text-md-right"
														onClick={(e) => {
															e.preventDefault();
															setShowCustomComplementaryPensionForm(true);
															setPayload({ ...payload, pensionComplementServiceId: "" });
															formRef.current.classList.remove("was-validated");
														}}>
														Cliquez ici si vous ne trouvez pas votre <span className="text-uppercase">régime</span> <i className="eva eva-plus-circle-outline fs-lead align-middle text-secondary"></i>
													</button>
												)}
											</div>
										)}
									</div>
									{showCustomComplementaryPensionForm ? (
										<CustomPensionForm index={index} payload={payload.customPensionComplement} setPayload={(val) => setPayload({ ...payload, customPensionComplement: val })} />
									) : (
										<div className="row gx-2 mt-n2">
											<div className="col-12 col-md-5">
												<div className="form-group">
													<label className="h6 font-weight-bolder my-auto" htmlFor={"companyName" + index}>
														Nom du régime
													</label>
													{pensionsComplementary.length == 1 ? (
														<input type="text" className="form-control" id={"companyName" + index} disabled placeholder="Entreprise" value={pensionsComplementary[0].name} />
													) : (
														<select
															className="custom-select"
															id={"pensionComplementary" + index}
															value={R.isNil(selectedPensionComplementary) ? "" : selectedPensionComplementary.name}
															onChange={(e) => {
																if (e.target.value === "") {
																	setPayload({ ...payload, pensionComplementServiceId: "" });
																} else {
																	let compPension = services.find((s) => s.name === e.target.value);
																	setPayload({ ...payload, pensionComplementServiceId: compPension.branches[0].id });
																}
															}}>
															<option value="">Veuillez choisir une option</option>
															{pensionsComplementary.map((pension, index) => {
																return (
																	<option key={index} value={pension.name}>
																		{pension.name}
																	</option>
																);
															})}
														</select>
													)}
												</div>
											</div>
											<div className="col-12 col-md-7">
												<div className="form-group">
													<label className="h6 font-weight-bolder my-auto" htmlFor={"branchComplementary" + index}>
														Agence
													</label>
													<select className="custom-select" id={"branchComplementary" + index} value={payload.pensionComplementServiceId} onChange={(e) => setPayload({ ...payload, pensionComplementServiceId: e.target.value })} required>
														{!R.isNil(selectedPensionComplementary) && selectedPensionComplementary.branches.length > 1 ? <option value="">Veuillez choisir une option</option> : ""}
														{!R.isNil(selectedPensionComplementary)
															? selectedPensionComplementary.branches.map((branch, index) => {
																	return (
																		<option key={index} value={branch.id}>
																			{branch.name}
																		</option>
																	);
															  })
															: ""}
													</select>
												</div>
												<div className="form-group">
													<div className="flex-row gx-2 align-items-center mb-1">
														<label className="label h6 font-weight-bold my-auto" htmlFor={"Adresseligne1" + index}>
															Adresse ligne 1
														</label>
														<p
															className="form-text small text-gray my-auto ml-auto"
															data-toggle="tooltip"
															data-placement="top"
															data-html="true"
															data-template='<div class="tooltip" role="tooltip"><div class="arrow"></div><div class="tooltip-inner px-3 py-2 fs-2"></div></div>'
															title="L'adresse de l'organisme est nécessaire afin de pouvoir le contacter et d'effectuer les démarches.">
															<i className="eva eva-info-outline mr-1 fs-sm lh-root align-middle"></i>
														</p>
													</div>
													<input type="text" className="form-control rounded" id={"Adresseligne1" + index} placeholder="Adresse de l'agence" value={R.isNil(branchComplementary) ? "" : branchComplementary.address.streetAddress} disabled="disabled" />
												</div>
												<div className="form-group">
													<label className="label h6 font-weight-bold my-auto" htmlFor={"Adresseligne2" + index}>
														Adresse ligne 2
													</label>
													<input type="text" className="form-control rounded" id={"Adresseligne2" + index} value={R.isNil(branchComplementary) ? "" : R.isNil(branchComplementary.address.streetAddress2) ? "" : branchComplementary.address.streetAddress2} disabled="disabled" />
												</div>
												<div className="form-row">
													<div className="form-group col-12 col-sm-6 col-lg">
														<label className="h6 font-weight-bolder my-auto" htmlFor={"Postalentreprise" + index} required>
															Code Postal
														</label>
														<input required type="text" className="form-control" id={"Postalentreprise" + index} placeholder="ex: 75001" value={R.isNil(branchComplementary) ? "" : branchComplementary.address.postalCode} disabled="disabled" />
														<div className="invalid-feedback">
															<i className="eva eva-alert-triangle-outline text-warning mr-1 fs-sm lh-root align-middle"></i>
															<span className="align-middle text-dark o-70">Ce champ est requis</span>
														</div>
													</div>
													<div className="form-group col-12 col-sm-6 col-lg">
														<label className="h6 font-weight-bolder my-auto" htmlFor={"Villeentreprise" + index} required>
															Ville
														</label>
														<input required type="text" className="form-control" id={"Villeentreprise" + index} placeholder="ex: Paris" value={R.isNil(branchComplementary) ? "" : branchComplementary.address.addressLocality} disabled="disabled" />
														<div className="invalid-feedback">
															<i className="eva eva-alert-triangle-outline text-warning mr-1 fs-sm lh-root align-middle"></i>
															<span className="align-middle text-dark o-70">Ce champ est requis</span>
														</div>
													</div>
													<div className="form-group col-12 col-sm-6 col-lg">
														<label className="h6 font-weight-bolder my-auto" htmlFor={"Paysentreprise" + index}>
															Pays
														</label>
														<select className="custom-select" id={"Paysentreprise" + index} value={R.isNil(branchComplementary) ? "" : branchComplementary.address.addressCountry} disabled="disabled">
															{Object.keys(contriesList.getData()).map((country, idx) => {
																return (
																	<option key={idx} value={country}>
																		{countries.getName(country, "fr", { select: "official" })}
																	</option>
																);
															})}
														</select>
													</div>
												</div>
											</div>
										</div>
									)}
								</React.Fragment>
							) : (
								""
							)}
						</React.Fragment>
					) : (
						""
					)}

					<hr className="my-0" />
					<div className="card-footer text-right px-0">
						{payload.professionalCategory === "" ? (
							<button className="btn btn-sm btn-alert-info border-none loading-btn disabled" disabled>
								enregistrer
							</button>
						) : (
							<button
								className="btn btn-sm btn-alert-info border-none loading-btn"
								onClick={(e) => {
									e.preventDefault();
									if (formRef.current.checkValidity()) {
										let serviceData = new ServiceData({ userId: user.user.id, serviceType: convertConnectionTypesToServiceType(ConnectionTypes.pension), serviceId: "pension" + index, payload: payload, lifeEvent: payload.lifeEvent || 1 });
										if (R.isNil(pension.id)) {
											dispatch(addServiceData(serviceData)).then((s) => {
												if (generateRelocationLetters) {
													dispatch(generateLettersForUserIdAndUserServiceId(user.user.id, s.id, "relocation"));
												}
											});
										} else {
											serviceData.id = pension.id;
											dispatch(updateServiceData(serviceData)).then((s) => {
												if (generateRelocationLetters) {
													dispatch(generateLettersForUserIdAndUserServiceId(user.user.id, s.id, "relocation"));
												}
											});
										}
										setCollapsed(!collapsed);
									}
									formRef.current.classList.add("was-validated");
								}}>
								enregistrer
								<div className="loading loading-spinner spinner-border spinner-border-sm ml-2 mr-n1"></div>
							</button>
						)}

						{index === 0 ? (
							""
						) : (
							<span
								className="btn btn-sm btn-icon px-xs btn-alert-danger ml-1 border-none"
								id="basic-addon2"
								onClick={(e) => {
									e.preventDefault();
									if (R.isNil(pension.id)) {
										removePension(pension);
									} else {
										dispatch(deleteServiceData(pension.id, ConnectionTypes.pension));
									}
								}}>
								<i className="eva eva-trash-outline"></i>
							</span>
						)}
					</div>
				</form>
			</div>
		</section>
	);
};
